import { useContext } from 'react';
import { Formik } from 'formik';
import { CircleLoader } from 'components';
import CarrierForm from './components';
import { carrierContext, carrierSchema } from './CarrierDetailsContext';

let CarrierDetails = () => {

    let service = useContext(carrierContext);

    return (
        <Formik
            enableReinitialize={true}
            initialValues={service.carrier}
            validationSchema={carrierSchema}
            onSubmit={(values, action) => {
                service.saveCarrier(values);
                action.setSubmitting(false);;
            }}
        >
            <>
                {service.isLoading && <CircleLoader />}
                {service.isLoading === false && <CarrierForm />}
            </>
        </Formik>
    )
}

export default CarrierDetails;